import TransactionReference from '@/generated/controls/transaction/TransactionReference.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: TransactionReference
})